
/* injects from baggage-loader */

'use strict';

import BulkServiceUpdateModalController from './bulkserviceupdatemodal.controller';
import BulkServiceUpdateModalTemplate from './bulkserviceupdatemodal.html';

export default class BulkServiceUpdateModalComponent {
		constructor() {
				this.templateUrl = BulkServiceUpdateModalTemplate;
				this.controller = BulkServiceUpdateModalController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = {
					resolve: '<',
					close: '&',
					dismiss: '&'
				};
		}
}
